/* stylelint-disable-file */
import { StyleSheet } from "@react-pdf/renderer";

export const pdfStyles = StyleSheet.create({
  page: {
    padding: 20,
    fontSize: 10,
    fontFamily: "Helvetica",
  },
  patientInfoHeader: {
    marginBottom: 16,
    paddingBottom: 10,
    borderBottomWidth: 1,
    borderBottomColor: "#ccc",
    gap: 6,
  },
  patientInfoRow: {
    flexDirection: "row",
    alignItems: "flex-start",
  },
  patientInfoCell: {
    width: "33%",
  },
  patientInfoCellRight: {
    width: "33%",
    alignItems: "flex-end",
  },
  patientInfoLabel: {
    fontSize: 9,
    color: "#666",
    marginBottom: 2,
  },
  patientInfoValue: {
    fontSize: 10,
  },
  header: {
    marginBottom: 10,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  weekTitle: {
    fontSize: 12,
    fontWeight: "bold",
  },
  dateRange: {
    fontSize: 10,
    color: "#666",
  },
  dayHeader: {
    fontSize: 10,
    fontWeight: "bold",
    paddingBottom: 6,
    borderBottomWidth: 2,
    borderBottomColor: "#000",
    marginBottom: 8,
  },
  exerciseCard: {
    marginBottom: 10,
    paddingTop: 8,
    paddingBottom: 8,
  },
  exerciseContent: {
    flexDirection: "row",
    gap: 15,
  },
  exerciseImage: {
    width: 150,
    height: 75,
    objectFit: "contain",
  },
  exerciseDetails: {
    flex: 1,
    gap: 10,
  },
  exerciseTitle: {
    fontSize: 12,
    fontWeight: "bold",
  },
  compactRepsInfo: {
    fontSize: 10,
  },
  sectionContent: {
    fontSize: 10,
    lineHeight: 1.4,
  },
  loadingText: {
    fontSize: 10,
    padding: 20,
    textAlign: "center",
  },
  errorText: {
    fontSize: 12,
    padding: 20,
    color: "#d32f2f",
  },
  pageNumber: {
    position: "absolute",
    fontSize: 10,
    bottom: 20,
    left: 0,
    right: 0,
    textAlign: "center",
    color: "grey",
  },
});
